<div class="align-centered">
  <img class="front-page__logo3" src="{{cdnImageUrl}}LabPort_logo_stackedcropped.png" alt="ClinDx">
  <h2>Oops Something went wrong</h2>
  <p> Labport is currently facing some issues. We are sorry for the inconvenience.
    <br> For IT Support, please contact <a routerLink="/contact-support">Eurofins helpdesk</a>
  </p>
  <button mat-raised-button color="primary" type="submit" value="Submit" (click)="goBack()">{{buttonText}}</button>
  @if (serverErrorDetails && supportEmialAddress) {
    <button hidden mat-raised-button class="ml-10" color="primary"
    (click)="reportErrorDetails()">Report Error Details</button>
  }
</div>